import axios from '@/api/axios'

export default {
  getPhoneIsExist (params) {
    return axios
      .get('/phone/is-exist', { params })
      .then((response) => response.data)
  },
}
